import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../filters';

export default {
  name: 'timePicker',
  components: {

  },
  props: {
    var: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    t: {
      type: String,
      default: '00:00:00 am'
    },
    format: {
      type: String,
      default: 'hh:mm:ss a'
    },
    showSeconds: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      tt: ['AM', 'PM'],

      h: '',
      m: '',
      s: '',
      a: '',
      title: '',

      time: ''
    }
  },
  created() {
    this.h = this.t.substring(0, 2);
    this.m = this.t.substring(3, 5);
    this.s = this.t.substring(6, 8);
    this.a = this.t.substring(9);
    this.title = this.label;

    for (var i = 0; i < 24; i++) {
      if (i.toString().length == 1)
        this.hours.push('0' + i.toString());
      else
        this.hours.push(i.toString());
    }

    for (var i = 0; i < 60; i++) {
      if (i.toString().length == 1) {
        this.minutes.push('0' + i.toString());
        this.seconds.push('0' + i.toString());
      }
      else {
        this.minutes.push(i.toString());
        this.seconds.push(i.toString());
      }
    }
  },
  watch: {
    h: function () {
      this.setDate();
    },
    m: function () {
      this.setDate();
    },
    s: function () {
      this.setDate();
    },
    a: function () {
      this.setDate();
    }
  },
  methods: {
    setDate() {
      this.time = this.h + ':' + this.m + ':' + this.s;

      var d = {
        time: this.time,
        var: this.var
      }
      this.$emit('timeChanged', d);
    }
  }
}

